import React, { useContext, useRef } from 'react';
import RcUpload from 'rc-upload';
import { useOnSuccess } from './hooks/use-on-success';
import { useOnProgress } from './hooks/use-on-progress';
import { useOnError } from './hooks/use-on-error';
import { useOnStart } from './hooks/use-on-start';
import { UploadStateContext } from './context';
import { UploadConfirm } from './upload-confirm';
export const UploadCore = (props) => {
    const { className } = props;
    const { beforeUpload, multiple, accept, getUploadAction, getUploadData, withCredentials, limited, } = useContext(UploadStateContext);
    const uploadRef = useRef(null);
    const onStart = useOnStart();
    const onProgress = useOnProgress();
    const onSuccess = useOnSuccess();
    const onError = useOnError();
    return (React.createElement(React.Fragment, null,
        React.createElement(UploadConfirm, { uploadRef: uploadRef }),
        React.createElement(RcUpload, { ref: uploadRef, className: className, withCredentials: withCredentials, name: "file", action: getUploadAction, disabled: limited, data: (file) => getUploadData(file) || {}, multiple: multiple, accept: accept, beforeUpload: beforeUpload, onStart: onStart, onSuccess: (res, file, xhr) => {
                if (res?.success === false) {
                    const err = new Error(res.errorMsg);
                    onError(err, res, file);
                    return;
                }
                onSuccess(res, file, xhr);
            }, onError: onError, onProgress: onProgress }, props.children)));
};
